export default __webpack_public_path__ + "static/media/wow-logo-white-anim.d7b066d9.svg";